/**
 * Tiny redirect components used to soft-land legacy RoofOps URLs onto their
 * fire-safety equivalents. Phase 12.
 *
 * Pattern: each component is a one-liner that calls navigate() inside a
 * useEffect so wouter has a chance to mount before we replace the URL.
 * Returns null so nothing flashes between the old URL and the redirect.
 */

import { useEffect } from "react";
import { useLocation } from "wouter";

function makeRedirect(target: string) {
  return function Redirect() {
    const [, navigate] = useLocation();
    useEffect(() => {
      navigate(target, { replace: true });
    }, [navigate]);
    return null;
  };
}

// Operations paths — soft-redirect to keep saved bookmarks alive.
export const RedirectJobsToVisits         = makeRedirect("/visits");
export const RedirectScheduleToVisits     = makeRedirect("/visits");
export const RedirectClientsToCustomers   = makeRedirect("/customers");
export const RedirectRecurringJobsToRecurring = makeRedirect("/recurring");
